import { motion } from "framer-motion";
import Chapter from "./Chapter";
import { FRAMEWORKS } from "@/lib/data";
import { IDS } from "@/lib/ids";

const FAMILY_ORDER = ["Security", "Privacy", "AI", "Sector"];

export default function FrameworksGrid() {
  const grouped = FAMILY_ORDER.map((fam) => ({
    fam,
    items: FRAMEWORKS.filter((f) => f.family === fam),
  }));

  return (
    <section id="frameworks" className="relative py-14 md:py-20 hairline-t">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Chapter number="05" label="20 frameworks · one map" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-10">
          <div className="lg:col-span-6">
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="font-display text-[36px] md:text-[54px] leading-[1.04] tracking-[-0.022em] text-balance"
            >
              Start ISO&nbsp;27001 <span className="grad-text">free</span>. Add frameworks as you grow.
            </motion.h2>
          </div>
          <div className="lg:col-span-6 lg:pt-3">
            <p className="text-ink-muted text-[15px] md:text-[17px] leading-relaxed max-w-[52ch]">
              Every framework here maps into the same canonical layer. Enable one, five, or all twenty — the evidence you've collected keeps counting.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10">
          {grouped.map((g) => (
            <div key={g.fam}>
              <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-ink-muted mb-4">
                {g.fam === "Sector" ? "Sector / Region" : g.fam}
              </div>
              <ul className="space-y-2">
                {g.items.map((f, i) => (
                  <motion.li
                    key={f.id}
                    data-testid={IDS.frameworkGridItem(f.id)}
                    initial={{ opacity: 0, y: 8 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.45, delay: i * 0.04 }}
                    className="group relative flex items-center gap-3 py-2 border-b border-white/6 hover:border-white/20 transition-colors"
                  >
                    <span className="w-1 h-1 rounded-full bg-white/25 group-hover:bg-brand-blue transition-colors" />
                    <span className="font-display text-[15px] flex-1">{f.name}</span>
                    <span className="font-mono text-[10px] text-white/45 tabular">{f.code}</span>
                    {f.tier === "Free" && (
                      <span className="ml-2 px-1.5 py-0.5 rounded-sm border border-brand-red/40 text-brand-red font-mono text-[9px] tracking-[0.18em] uppercase">Free</span>
                    )}
                  </motion.li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
